module.exports = __webpack_public_path__ + "static/colaboradores-06-fb983f0f70349385ad3c564590e21ffe.png";